import React from "react";
import { GrayBorderBox } from "../../../../styles/boxes";
import { GrayButton } from "../../../../styles/buttons";

// Importar los componentes de título y subtítulo
import {
  AlignedBoxTitle,
  AlignedBoxSubTitle,
  // Importa otros componentes si es necesario
} from "../../../../styles/texts";

interface InfoCardProps {
  logo: React.ReactNode;
  title: string;
  subtitle: string;
  buttonText: string;
  onButtonClick?: () => void;
}

const InfoCard: React.FC<InfoCardProps> = ({
  logo,
  title,
  subtitle,
  buttonText,
  onButtonClick,
}) => {
  return (
    <GrayBorderBox
      w="100%"
      h="auto"
      p="16px 16px 16px 23.5px" // padding-top, padding-right, padding-bottom, padding-left
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          gap: "16px", // Espacio entre el contenido principal y el botón
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "15.5px", // Espacio entre logo y texto
          }}
        >
          {/* Logo */}
          <div
            style={{
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              width: "40px", // Ancho deseado del logo
              height: "40px", // Alto deseado del logo
            }}
          >
            {/* Clonar el logo para aplicar estilos */}
            {React.cloneElement(logo as React.ReactElement, {
              style: { width: "100%", height: "100%", objectFit: "contain" },
            })}
          </div>

          {/* Título y Subtítulo usando componentes personalizados */}
          <div className="flex flex-col items-left">
            {/* Usar BoxTitle para el título */}
            <AlignedBoxTitle fontSize="20px">{title}</AlignedBoxTitle>
            <AlignedBoxSubTitle fontSize="14px">{subtitle}</AlignedBoxSubTitle>
          </div>
        </div>

        {/* Botón */}
        <div style={{ flexShrink: 0 }}>
          <GrayButton
            label={buttonText}
            onClick={onButtonClick}
            w="full"
            h="40px"
          />
        </div>
      </div>
    </GrayBorderBox>
  );
};

export default InfoCard;
